module.exports = __webpack_public_path__ + "static/media/shape.129cf21f.svg";